import React, { useState } from "react";

import { GetReportEnergy, GetReportEnergyXlsx } from "../../api/report";

const ReportEnergy = ({ token }) => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [report, setReport] = useState(null);
  const [error, setError] = useState("");

  async function loadReport() {
    if (!startDate || !endDate) {
      setError("Укажите начало и конец периода");
      return;
    }

    setError("");
    const response = await GetReportEnergy(token, startDate, endDate);
    if (response?.detail) {
      setError(response.detail);
      setReport(null);
      return;
    }
    setReport(response);
  }

  async function downloadReport() {
    if (!startDate || !endDate) {
      setError("Укажите начало и конец периода");
      return;
    }

    setError("");
    const response = await GetReportEnergyXlsx(token, startDate, endDate);
    if (!response?.data) {
      setError("Не удалось скачать отчет");
      return;
    }

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;

    const contentDisposition = response.headers["content-disposition"];
    let filename = "energy_report.xlsx";
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename="?([^\"]+)"?/);
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1];
        // Fix: Remove trailing .xlsx_ or .xlsx_.* if exists and ensure it ends in .xlsx
        filename = filename.replace(/\.xlsx_?[^\.]*$/, ".xlsx");
      }
    }

    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12" style={{ marginTop: "1%" }}>
          <h1 className="text-center">Отчет по электроэнергии</h1>
        </div>

        <div className="col-md-3 text-center" style={{ marginTop: "3%" }}>
          <label className="form-label">Начало периода</label>
          <input
            className="form-control"
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </div>

        <div className="col-md-3 text-center" style={{ marginTop: "3%" }}>
          <label className="form-label">Конец периода</label>
          <input
            className="form-control"
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div>

        <div className="col-md-3" style={{ marginTop: "5.8%" }}>
          <button className="btn btn-primary w-100" onClick={loadReport}>
            Показать
          </button>
        </div>

        <div className="col-md-3" style={{ marginTop: "5.8%" }}>
          <button className="btn btn-success w-100" onClick={downloadReport}>
            Скачать .xlsx
          </button>
        </div>
      </div>

      {error && (
        <div className="row" style={{ marginTop: "3%" }}>
          <div className="col-md-12">
            <div className="alert alert-danger">{error}</div>
          </div>
        </div>
      )}

      {report && (
        <>
          <div className="row" style={{ marginTop: "5%" }}>
            <div className="col-md-12">
              <p>
                Период: {report.start_date} — {report.end_date}
              </p>
              <p>
                <strong>Итого расход: {report.total_diff} кВт·ч</strong>
              </p>
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Ресторан</th>
                    <th>Устройств</th>
                    <th>Расход (кВт·ч)</th>
                  </tr>
                </thead>
                <tbody>
                  {report.restaurants.map((restaurant) => (
                    <tr key={restaurant.restaurant_id}>
                      <td>{restaurant.restaurant_name}</td>
                      <td>{restaurant.device_count}</td>
                      <td>{restaurant.total_diff}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="row" style={{ marginTop: "5%" }}>
            <div className="col-md-12">
              <h4>По часам</h4>
              <div style={{ overflowX: "auto" }}>
                <table className="table table-bordered table-sm">
                  <thead>
                    <tr>
                      <th style={{ position: "sticky", left: 0, background: "#fff" }}>
                        Ресторан
                      </th>
                      <th style={{ position: "sticky", left: 120, background: "#fff" }}>
                        Устройство
                      </th>
                      {report.hours?.map((hour) => (
                        <th key={hour} className="text-center text-nowrap">
                          {hour}
                        </th>
                      ))}
                      <th className="text-center text-nowrap">Итого</th>
                    </tr>
                  </thead>
                  <tbody>
                    {report.devices?.map((device) => (
                      <tr key={device.device_id}>
                        <td style={{ position: "sticky", left: 0, background: "#fff" }}>
                          {device.restaurant_name}
                        </td>
                        <td style={{ position: "sticky", left: 120, background: "#fff" }}>
                          {device.device_name}
                        </td>
                        {device.hourly?.map((value, index) => (
                          <td key={`${device.device_id}-${index}`} className="text-center">
                            {value}
                          </td>
                        ))}
                        <td className="text-center fw-bold">{device.total_diff}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ReportEnergy;
